import { get } from 'lodash';
import doMatchedRoutesMatch from './doMatchedRoutesMatch';

// Most `/app` routes require authentication and most
// non-`/app` routes do not require authentication.
// Routes that break this convention specify it via `isAuthRequired`
const defaultIsAuthRequired = route =>
  get(route, 'path', '').indexOf('/app') > -1;

const isAuthRequiredForMatchedRoutes = doMatchedRoutesMatch(route => {
  return route.isAuthRequired !== undefined
    ? route.isAuthRequired
    : defaultIsAuthRequired(route);
});

export default isAuthRequiredForMatchedRoutes;
